function Footer() {
  return (
    <footer
      style={{
        marginTop: "80px",
        marginLeft: "auto",
        marginRight: "auto",
        width: "90%",
        textAlign: "center",
      }}
    >
      <hr />
      Copyright &copy; 2023 Oscar Kim.
    </footer>
  );
}

export default Footer;
